import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Services } from "@/components/site/Services";
import { Stats } from "@/components/site/Stats";
import { Manifesto } from "@/components/site/Manifesto";
import { Projects } from "@/components/site/Projects";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  useLenis();
  return (
    <main className="bg-ink" data-testid="home-page">
      <Nav />
      <Hero />
      <Ribbon />
      <Services />
      <Stats />
      <Manifesto />
      <Projects />
      <Contact />
      <Footer />
    </main>
  );
}
